import { render, staticRenderFns } from "./StsDownloadButton.vue?vue&type=template&id=3ff7432a&"
import script from "./StsDownloadButton.vue?vue&type=script&lang=js&"
export * from "./StsDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports